import { Action } from '@ngrx/store';

export enum ActionTypes {
    ADD = '[Progress] Add',
    REMOVE = '[Progress] Remove'
}

export class Add implements Action {
    readonly type = ActionTypes.ADD;

    constructor(public payload: string) {}
}

export class Remove implements Action {
    readonly type = ActionTypes.REMOVE;

    constructor(public payload: string) {}
}


export type Actions =
    | Add
    | Remove
    ;
